import styled from 'styled-components';

export const ScheduleStyled = styled.div`
  padding: ${props => props.theme.size.rap};

  .content {
    width: 100%;
    background: #fff;
    margin-bottom: 1rem;
    border-radius: ${props => props.theme.size.borderRadius};
    padding: ${props => props.theme.size.rap};
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  }

  .content-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;

    span {
      color: #999;
      font-size: 0.9rem;
    }
  }

  .calendar-content {
    display: flex;
    margin-bottom: 1rem;

    & > div {
      flex: 1;
    }

    .day-item {
      text-align: center;

      .week {
        padding-bottom: 0.5rem;
      }

      .day {
        position: relative;
        z-index: 1;
        padding: 0.5rem 0;

        &:before {
          position: absolute;
          z-index: -1;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 1.7rem;
          height: 1.7rem;
          border-radius: 50%;
          content: '';
          display: none;
        }
        &.has:before {
          display: block;
          background: #ededed;
        }
        &.active {
          color: #fff;
        }
        &.active:before {
          display: block;
          background: ${props => props.theme.color.primary};
        }
      }
    }
  }

  .history-content {
    .empty {
      display: flex;
      padding-top: 4rem;
      padding-bottom: 4rem;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      font-size: 1.5rem;
      color: #ccc;

      .icon {
        margin-bottom: 1rem;
        font-size: 5rem;
        line-height: 1em;
      }
    }
  }

  .history-item {
    margin-bottom: 2rem;
    .title {
      margin-bottom: 1rem;
      font-size: 1.1rem;
      font-weight: bold;
    }
    .bottom {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  }

  margin-bottom: 4rem;
`;
